export const InstituteStatus = {
  New: {value: "NEW", label: "New"},
  Approved: {value: "APPROVED", label: "Approved"},
  Declined: {value: "DECLINED", label: "Declined"},
  Inactive: {value: "INACTIVE", label: "Inactive"},
  Blacklisted: {value: "BLACKLISTED", label: "Blacklisted"},
  NonCompliant: {value: "NONCOMPLIANT", label: "Non-Compliant"},
  Duplicate: {value: "DUPLICATE", label: "Duplicate"},
};

export const isInstituteStatusApproved = (status: string) => {
  return InstituteStatusesByValue.get(status) == InstituteStatus.Approved;
}

export const InstituteStatusesByValue = new Map<string, typeof InstituteStatus[keyof typeof InstituteStatus]>(
  Object.values(InstituteStatus).map((entry) => [entry.value, entry])
)
